// Sorting an array in desc order and put zero always at end.
export function ascendingSorting(input) {
  return input.sort((a, b) => !a - !b || a - b);
}
